import { useState } from 'react';

const STEPS = [
  {
    emoji: '📚',
    title: 'Добро пожаловать в 2EnBota!',
    text: 'Учи английские слова через интервальные повторения. Твой прогресс сохраняется автоматически.',
  },
  {
    emoji: '🎯',
    title: 'Режимы обучения',
    text: 'MC — выбирай из 4 вариантов. Input — набирай перевод. Audition — слушай и выбирай. Dictation — слушай и пиши.',
  },
  {
    emoji: '🔄',
    title: 'Умные повторения (SRS)',
    text: 'После изучения слово попадает в расписание. Система сама напомнит о нём в нужное время — от 8 часов до 120 дней.',
  },
  {
    emoji: '🎮',
    title: 'RPG-прогресс',
    text: 'За каждый ответ ты получаешь опыт, прокачиваешь персонажа и находишь предметы. Иногда падает редкий лут!',
  },
  {
    emoji: '🚀',
    title: 'Начнём!',
    text: 'Выбери быстрый старт с 100 готовых слов или добавь своё первое слово. Всё настраивается под тебя.',
  },
];

interface Props {
  onDone: () => void;
  onAddTop100?: () => void;
  onAddCustomWord?: () => void;
}

export function OnboardingOverlay({ onDone, onAddTop100, onAddCustomWord }: Props) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.85)',
      zIndex: 2000,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--theme-bg-elevated)',
        borderRadius: '24px 24px 0 0',
        padding: '32px 24px 48px',
        width: '100%',
        maxWidth: 480,
        animation: 'slideUp 0.35s ease',
        textAlign: 'center',
      }}>
        {/* Dots */}
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 28 }}>
          {STEPS.map((_, i) => (
            <div key={i} style={{
              width: i === step ? 20 : 6, height: 6,
              borderRadius: 3,
              background: i === step ? 'var(--theme-primary)' : 'var(--theme-border)',
              transition: 'width 0.3s ease, background 0.3s ease',
            }} />
          ))}
        </div>

        <div style={{ fontSize: 64, marginBottom: 20, animation: 'fadeIn 0.3s ease' }}>
          {current.emoji}
        </div>
        <div style={{
          fontSize: 20, fontWeight: 700,
          color: 'var(--theme-text)', marginBottom: 12,
        }}>
          {current.title}
        </div>
        <div style={{
          fontSize: 15, color: 'var(--theme-text-secondary)',
          lineHeight: 1.6, marginBottom: 32,
        }}>
          {current.text}
        </div>

        {isLast ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {onAddTop100 && (
              <button onClick={onAddTop100} style={{
                width: '100%', padding: '16px',
                background: 'var(--theme-primary)', color: 'var(--theme-primary-text)',
                border: 'none', borderRadius: 12,
                fontSize: 16, fontWeight: 700, cursor: 'pointer',
              }}>
                🚀 Добавить 100 базовых слов
              </button>
            )}
            {onAddCustomWord && (
              <button onClick={onAddCustomWord} style={{
                width: '100%', padding: '16px',
                background: 'var(--theme-bg-card)', color: 'var(--theme-text)',
                border: '1px solid var(--theme-border)', borderRadius: 12,
                fontSize: 15, fontWeight: 600, cursor: 'pointer',
              }}>
                ✍️ Добавить своё слово
              </button>
            )}
            <button onClick={onDone} style={{
              background: 'none', border: 'none',
              color: 'var(--theme-text-muted)', fontSize: 14,
              cursor: 'pointer', marginTop: 4,
            }}>
              Пропустить, я разберусь сам
            </button>
          </div>
        ) : (
          <button onClick={() => setStep(s => s + 1)} style={{
            width: '100%', padding: '16px',
            background: 'var(--theme-primary)', color: 'var(--theme-primary-text)',
            border: 'none', borderRadius: 12,
            fontSize: 16, fontWeight: 700, cursor: 'pointer',
          }}>
            Далее →
          </button>
        )}
      </div>
    </div>
  );
}
